export const mobilePhoneData = {
  success: true,
  message: 'Verification code was sent to +16505130514',
  mobilePhone: '+16505130514',
};
